import React from 'react';
import { useDispatch, useSelector} from 'react-redux';
import { LinkContainer } from 'react-router-bootstrap';
import { Navbar, Nav, Container, NavDropdown } from 'react-bootstrap';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useLogoutTeacherMutation } from '../slices/teachers/teachersApiSlice';
import { useGetTeacherNewQuestionsQuery } from '../slices/teachers/teacherQuestionsApiSlice';
import { logoutTeacher } from '../slices/teachers/authTeacherSlice';

const TeacherHeader = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { pageNumber } = useParams();

  const { teacherInfo } = useSelector(state => state.authTeacher);

  const { data, isLoading, error } = useGetTeacherNewQuestionsQuery({pageNumber});

  const [logoutApiCall] = useLogoutTeacherMutation();

  const logoutHandler = async () => {
    try {
      await logoutApiCall().unwrap();
      dispatch(logoutTeacher());
      navigate('/teacherlogin');
    } catch (err) {
      console.log(err);
    }
  }

  return (
    <div className="main-content " id="panel">
      <nav className="navbar navbar-top navbar-expand navbar-dark border-bottom navbg">
        <div className="container-fluid">
          <div className="collapse navbar-collapse" id="navbarSupportedContent">        
            <ul className="navbar-nav align-items-center  ml-auto ">
              <li className="nav-item ">
                <div className="pr-3 sidenav-toggler sidenav-toggler-dark" data-action="sidenav-pin" data-target="#sidenav-main">
                  <div className="sidenav-toggler-inner">
                    <i className="sidenav-toggler-line"></i>
                    <i className="sidenav-toggler-line"></i>
                    <i className="sidenav-toggler-line"></i>
                  </div>
                  
                </div>
              </li>
              <li className="nav-item d-sm-none search22">
                <a className="nav-link" href="#" data-action="search-show" data-target="#navbar-search-main">
                  <i className="ni ni-zoom-split-in"></i>
                </a>
              </li>
              <li className="nav-item dropdown navBadge">
                <a className="nav-link" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <i className="ni ni-bell-55"></i>
                </a>
                <span className="button__badge2 notif23">{data?.count}</span>
                <div className="dropdown-menu dropdown-menu-xl  dropdown-menu-right  py-0 overflow-hidden">
                  <div className="px-3 py-3">
                    <h6 className="text-sm text-muted m-0 text-center">You have <strong className="text-primary">{data?.count}</strong> new questions</h6>
                  </div>                  
                </div>
              </li>             
            {/* </ul>
            <ul className="navbar-nav align-items-center  ml-auto ml-md-0 "> */}
              <li className="nav-item dropdown ">
                  <div className="media align-items-center notBell">                  
                    {teacherInfo ? ( 
                      <>
                        {/* <span className="avatar avatar-sm rounded-circle">
                        <img alt="Image placeholder" src="../../../assets/img/theme/team-3.jpg" />                      
                        </span> */}
                          <div className="media-body  ml-2  d-none d-lg-block mouseP">
                            <span className="mb-0 text-sm  font-weight-bold navText" onClick={logoutHandler}> Logout</span>
                          </div>
                      </>     
                      ) : ( 
                        <p></p>
                    )}                     
                  </div>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  )
}

export default TeacherHeader;